import IconExcel from './component.jsx'
export default IconExcel
